/* eslint-env browser */

require('../../container/client')

const MapboxGeocoder = require('mapbox-gl-geocoder')
const FilterControl = require('./filter-control')

const UnitsService = require('../../client/clientjs/services/units-service')
const DomHelper = require('../../client/clientjs/dom-helper')

const { origin } = window.location
const userUnitSystem = UnitsService.unitSystemFrom(
  window.initialState.locale.identifier,
  window.initialState.userSettings
)

const allBusinessTypes = window.initialState.allBusinessTypes
  .map(elt => {
    if (!elt.iconName || elt.iconName === 'null') {
      elt.iconName = 'other'
    }
    return elt
  })
  .sort((a, b) => (a.order || 0) - (b.order || 0))

const allBusinessTypesById = allBusinessTypes.reduce((aggreg, elt) => {
  aggreg[elt.id] = elt
  return aggreg
}, {})
const iconsToLoad = allBusinessTypes.reduce((aggreg, item) => {
  if (aggreg.indexOf(item.iconName) === -1 && item.iconName) {
    aggreg.push(item.iconName)
  }
  return aggreg
}, [])
const mapboxBusinessTypeIdIconFilter = allBusinessTypes.reduce((aggreg, elt) => {
  aggreg.push(elt.id)
  aggreg.push(elt.iconName)
  return aggreg
}, [])

function loadDefaultIcon(map) {
  return new Promise(function(resolve, reject) {
    map.loadImage('https://statics.fishfriender.com/statics/map/markers_icons/other.png', function(error, otherData) {
      if (error) {
        return reject(error)
      }
      return resolve(otherData)
    })
  })
}

function loadAllIcons(map) {
  return loadDefaultIcon(map).then(function(otherData) {
    return Promise.all(
      iconsToLoad.map(
        i =>
          new Promise(function(resolve) {
            map.loadImage(`https://statics.fishfriender.com/statics/map/markers_icons/${i}.png`, function(error, data) {
              if (error) {
                map.addImage(i, otherData)
                return resolve(otherData)
              }
              map.addImage(i, data)
              return resolve(data)
            })
          })
      )
    )
  })
}

DomHelper.onDocumentReady(() => {
  const { mapboxgl } = window
  if (!mapboxgl) {
    return
  }
  mapboxgl.accessToken = window.initialState.config.mapboxAccessToken

  const map = new mapboxgl.Map({
    hash: true,
    container: 'map',
    style: 'mapbox://styles/philippeauriach/cj6w4qfvd018h2rqvvvj9ge00',
  })
  map.addControl(
    new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
    }),
    'top-right'
  )
  map.addControl(new mapboxgl.GeolocateControl(), 'bottom-right')
  map.addControl(
    new mapboxgl.ScaleControl({
      maxWidth: 80,
      unit: userUnitSystem === 'IMPERIAL' ? 'imperial' : 'metric',
    }),
    'bottom-left'
  )
  map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')

  const selection = allBusinessTypes.reduce((aggreg, elt) => {
    aggreg[elt.id] = true
    return aggreg
  }, {})
  map.addControl(
    new FilterControl({
      allBusinessTypes,
      selected: selection,
      onSelectionChanged: newSelection => {
        map.setFilter('businesses', ['in', 'typeId', ...Object.keys(newSelection).filter(elt => newSelection[elt])])
      },
    }),
    'top-right'
  )

  map.on('load', function() {
    map.addSource('fishfriender-businesses', {
      type: 'vector',
      tiles: [`${origin}/api/map/layers/businesses/{z}/{x}/{y}.mvt`],
    })
    /*
    map.addSource('fishfriender-hydro', {
      type: 'vector',
      tiles: [`${origin}/api/map/hydro/{z}/{x}/{y}.mvt`],
    })
    */

    const riverColor = '#1500ff'
    /* map.addLayer({
      id: 'hydro-line',
      source: 'fishfriender-hydro',
      'source-layer': 'hydro',
      type: 'fill',
      minzoom: 1,
      paint: {
        'fill-color': riverColor,
        'fill-opacity': 0.5,
        //        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0, 11, 1, 13.5, 1, 14.5, 0.5, 18, 0.2],
      },
    })
    map.addLayer({
      id: 'hydro-fill',
      source: 'fishfriender-hydro',
      'source-layer': 'hydro',
      type: 'line',
      minzoom: 1,
      paint: {
        'line-color': 'red',
        'line-opacity': 0.5,
        //        'line-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0, 11, 1, 13.5, 1, 14.5, 0],
        'line-width': 1.5,
      },
    })
     */

    /*
    map.addSource('fishfriender-public-spots', {
      type: 'vector',
      tiles: [`${origin}/api/map/catches/{z}/{x}/{y}.mvt`],
    })
    map.addLayer({
      id: 'catches',
      source: 'fishfriender-public-spots',
      'source-layer': 'catches',
      type: 'circle',
      paint: {
        'circle-radius': 1,
        'circle-color': 'orange',
      },
    })
    */

    /*
    // using mapbox hosted tileset, much more efficient
    map.addSource('public-catches-ts-dev', {
      type: 'vector',
      url: 'mapbox://philippeauriach.public-catches-ts-dev',
    })
    map.addLayer({
      id: 'philippeauriach.public-catches-ts-dev',
      source: 'public-catches-ts-dev',
      'source-layer': 'catches',
      type: 'circle',
      paint: {
        'circle-radius': 4,
        'circle-color': 'orange',
      },
    })
    */
    /*
    map.addLayer({
      id: 'philippeauriach.public-catches-ts-dev-10m',
      source: 'public-catches-ts-dev',
      'source-layer': 'catches10m',
      type: 'circle',
      paint: {
        'circle-radius': 4,
        'circle-color': 'orange',
      },
    })
    map.addLayer({
      id: 'philippeauriach.public-catches-ts-dev-1m',
      source: 'public-catches-ts-dev',
      'source-layer': 'catches1m',
      type: 'circle',
      paint: {
        'circle-radius': 4,
        'circle-color': 'orange',
      },
    })
    map.addLayer({
      id: 'philippeauriach.public-catches-ts-dev-30cm',
      source: 'public-catches-ts-dev',
      'source-layer': 'catches30cm',
      type: 'circle',
      paint: {
        'circle-radius': 4,
        'circle-color': 'orange',
      },
    })
    */

    loadAllIcons(map).then(() => {
      const layer = {
        id: 'businesses',
        source: 'fishfriender-businesses',
        'source-layer': 'businesses',
        type: 'symbol',
        layout: {
          'icon-image': [
            'match',
            ['to-string', ['get', 'typeId']],
            ...mapboxBusinessTypeIdIconFilter,
            /* other */ 'other',
          ],
          'icon-size': ['interpolate', ['linear'], ['zoom'], 3, 0.1, 7, 0.3, 12, 0.4, 20, 0.7],
          'icon-anchor': 'bottom',
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
        },
        paint: {},
      }
      map.addLayer(layer)
      map.addSource('fishfriender-businesses-hover', {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
      })
      const hoveredLayer = {
        id: 'businesses-hover',
        source: 'fishfriender-businesses-hover',
        type: 'symbol',
        layout: {
          'icon-image': [
            'match',
            ['to-string', ['get', 'typeId']],
            ...mapboxBusinessTypeIdIconFilter,
            /* other */ 'other',
          ],
          'icon-size': ['interpolate', ['linear'], ['zoom'], 3, 0.12, 7, 0.36, 12, 0.48, 20, 0.84],
          'icon-anchor': 'bottom',
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          /* 'text-field': ['get', 'name'],
        'text-anchor': 'top' */
        },
      }
      map.addLayer(hoveredLayer)

      let popup
      map.on('mousemove', e => {
        const features = map.queryRenderedFeatures(e.point, { layers: ['businesses'] }) || []
        map.getSource('fishfriender-businesses-hover').setData({
          type: 'FeatureCollection',
          features: features.length === 0 ? [] : [{ type: 'Feature', ...features[0] }],
        })
        if (features.length) {
          map.getCanvas().style.cursor = 'pointer'
          if (popup) {
            popup.remove()
            popup = null
          }
          const popupContent = document.createElement('div')
          const businessType = allBusinessTypesById[features[0].properties.typeId]
          const biz = features[0].properties
          if (biz.imageLittleUrl === 'null') {
            delete biz.imageLittleUrl
          }
          popupContent.innerHTML = `<table>
          <tr>
            <td><img width="100" height="70" src="${biz.imageLittleUrl ||
              biz.imageUrl}" style="object-fit: contain;"/></td>
            <td>
              <b>${businessType.name}</b><br><h6>${biz.name}</h6>
            </td>
          </tr>
        </table>`
          popup = new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: false,
            offset: {
              bottom: [0, -20],
            },
          })
            .setLngLat(e.lngLat)
            .setDOMContent(popupContent)
            .addTo(map)
          // popupContent.parentNode.parentNode.style.backgroundColor = 'orange';
        } else {
          map.getCanvas().style.cursor = ''
          if (popup) {
            popup.remove()
            popup = null
          }
        }
      })
      map.on('click', e => {
        const features = map.queryRenderedFeatures(e.point, { layers: ['businesses'] })
        map.getSource('fishfriender-businesses-hover').setData({
          type: 'FeatureCollection',
          features: features.length === 0 ? [] : [{ type: 'Feature', ...features[0] }],
        })
        if (features.length) {
          window.open(`/businesses/${features[0].properties.id}`, '_blank')
        }
      })
    })
  })
})

if (module.hot) {
  module.hot.accept()
}
